export const getDateTime = (unixTimestamp: number): string => {
  return new Date(unixTimestamp * 1000).toLocaleString('en-US');
};
